import React from "react";
import cn from "clsx";

export default function Checkbox({
  value,
  onChangeFunc,
  name,
  onBlur,
  disabled = false,
  id,
  isDark = false,
  style = {},
}: {
  name?: string;
  value: boolean;
  onChangeFunc: (value: boolean) => void;
  onBlur?: () => void;
  disabled?: boolean;
  isDark?: boolean;
  style?: any;
  id?: string;
}) {
  return (
    <label>
      <input
        type="checkbox"
        checked={value}
        id={id}
        name={name}
        onChange={() => onChangeFunc(!value)}
        onBlur={onBlur}
        aria-label="Checkbox"
        style={style}
        disabled={disabled}
        className={cn(
          "outline-none rounded-[50%] align-middle border-[1px] border-stone-500 appearance-none cursor-pointer",
          value &&
            !isDark &&
            "checked:bg-primary-blue checked:border-transparent checked:ring-2 checked:ring-primary-blue checked:ring-offset-2 checked:ring-offset-white",
          value &&
            isDark &&
            "checked:bg-white checked:border-transparent checked:ring-2 checked:ring-white checked:ring-offset-2 checked:ring-offset-black",
          isDark && "bg-transparent border-stone-500 text-white",
        )}
      />
    </label>
  );
}
